import majorProjects from "./majorProjects/majorProjects";
import siteSketches from "./siteSketches/siteSketches";
import { getPathnames } from "./use-pathnames";

const pathnamesBase = {
  majorProjects,
  siteSketches
};

const pathnames = getPathnames(pathnamesBase) as typeof pathnamesBase;

export default pathnames;
